import {EmailPromotionType} from '@optimaxdev/analytics/mobile';

export const CARD_TYPE = {
    DEBIT: 'DEBIT',
    PREPAID: 'PREPAID',
};
export const ADDRESS = {
    SHIPPING: 'shipping_address',
    BILLING: 'billing_address',
};

export const CHECKBOX_STATUS: {[key: string]: EmailPromotionType} = {
    CHECKED: 'Marked',
    UNCHECKED: 'Unmarked',
    UNSEEN: 'Not showed',
};
